"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const apollo_client_1 = require("apollo-client");
const react_1 = require("react");
class OsmosysClientError extends apollo_client_1.ApolloError {
    constructor() {
        super(...arguments);
        this.graphQLErrors = [];
    }
}
const ARGUMENT_VALIDATION_ERROR = 'Argument Validation Error';
const ERROR_MAPPINGS = [
    {
        find: 'GraphQL error: ',
        replace: '',
    },
    {
        find: 'Network error: Failed to fetch: ',
        replace: 'Network error: You may be offline or Osmosys may experiencing an issue. (Error #1)',
    },
    {
        find: 'Network error: Response not successful: Received status code 400',
        replace: 'Network error: You may be offline or Osmosys may experiencing an issue. (Error #2)',
        replaceAll: true,
    },
    {
        find: 'Network error: Unexpected token',
        replace: 'Network error: You may be offline or Osmosys is unreachable. (Error #3)',
        replaceAll: true,
    },
    {
        find: ARGUMENT_VALIDATION_ERROR,
        replace: 'Invalid request. Please check the your form to make sure it is valid. If everything seems okay, please contact support@yellowbrim.com.',
        replaceAll: true,
    },
    {
        find: 'Network error: undefined',
        replace: 'Network error: You may be offline or Osmosys may experiencing an issue. (Error #4)',
        replaceAll: true,
    },
];
// TODO: REMOVE THIS BLOCKER
const matchedErrorMapping = ERROR_MAPPINGS.find(em => {
    return !!em.match;
});
if (matchedErrorMapping) {
    throw new Error('Using regex is not yet supported. This is a TODO.');
}
const trimAndAddPeriod = (str) => {
    let newStr = str.trim();
    if (!(newStr.endsWith('.') ||
        newStr.endsWith('?') ||
        newStr.endsWith('!') ||
        newStr.endsWith('.)'))) {
        newStr += '.';
    }
    return newStr;
};
const returnValidationError = (validationErrors) => {
    console.warn({ fn: 'returnValidationError', validationErrors });
    const firstError = validationErrors[0];
    if (firstError.constraints) {
        if (firstError.constraints.customText) {
            return firstError.constraints.customText;
        }
        const firstErrorKey = Object.keys(firstError.constraints || {})[0];
        if (firstErrorKey) {
            return firstError.constraints[firstErrorKey];
        }
    }
};
exports.findAndReplaceWithErrorMapping = (errorObject) => {
    console.warn({ errorObject, fn: 'findAndReplaceWithErrorMapping' });
    let newMessage = errorObject.message;
    // 1
    if (newMessage.includes(ARGUMENT_VALIDATION_ERROR) &&
        errorObject.graphQLErrors &&
        errorObject.graphQLErrors[0] &&
        errorObject.graphQLErrors[0].extensions &&
        errorObject.graphQLErrors[0].extensions.exception &&
        errorObject.graphQLErrors[0].extensions.exception.validationErrors &&
        errorObject.graphQLErrors[0].extensions.exception.validationErrors[0] &&
        errorObject.graphQLErrors[0].extensions.exception.validationErrors[0]
            .constraints &&
        typeof errorObject.graphQLErrors[0].extensions.exception.validationErrors[0]
            .constraints === 'object' &&
        Object.keys(errorObject.graphQLErrors[0].extensions.exception.validationErrors[0]
            .constraints)[0].length > 0) {
        newMessage =
            returnValidationError(errorObject.graphQLErrors[0].extensions.exception.validationErrors) || '';
        if (newMessage) {
            return trimAndAddPeriod(newMessage);
        }
    }
    // 2
    if (newMessage) {
        ERROR_MAPPINGS.forEach(mappingEntry => {
            if (mappingEntry.find &&
                mappingEntry.replaceAll &&
                newMessage.includes(mappingEntry.find)) {
                newMessage = mappingEntry.replace;
            }
            else if (mappingEntry.find && newMessage.includes(mappingEntry.find)) {
                newMessage = newMessage.replace(mappingEntry.find, mappingEntry.replace);
            }
            else if (mappingEntry.match && newMessage.match(mappingEntry.match)) {
                // newMessage = newMessage.replace(mappingEntry.find, mappingEntry.replace);
            }
        });
    }
    return trimAndAddPeriod(newMessage);
};
exports.useOsmosysError = (error) => {
    return react_1.useMemo(() => {
        if (!error) {
            return '';
        }
        return exports.findAndReplaceWithErrorMapping(error);
    }, [error]);
};
//# sourceMappingURL=useOsmosysError.js.map